import React from "react";
import { Nav } from "react-bootstrap";

export default function CategorySelect({ activeCategory, setActiveCategory }) {
  let categories = [
    "shirts",
    "longsleeves",
    "shorts",
    "trousers",
    "others",
    "lost",
  ];

  let colors = [
    "#f94144",
    "#f3722c",
    "#f9c74f",
    "#90be6d",
    "#43aa8b",
    "#277da1",
  ];

  let categories_src = [
    "shirt.png",
    "longsleeve.png",
    "short.png",
    "trousers.png",
    "others.png",
    "lost.png",
  ];

  let items = [];
  for (let i = 0; i < categories_src.length; i++) {
    let imageSrc = categories_src[i];
    items.push(
      <Nav.Item key={categories[i]}>
        <Nav.Link
          eventKey={categories[i]}
          active={activeCategory === categories[i]}
          style={{
            margin: "5%",
            padding: "0px",
            backgroundColor: colors[i],
            borderTopLeftRadius: i === 0 ? "20px" : "0px",
            borderTopRightRadius:
              i === categories_src.length - 1 ? "20px" : "0px",
            borderBottomLeftRadius: i === 0 ? "10px" : "0px",
            borderBottomRightRadius:
              i === categories_src.length - 1 ? "10px" : "0px",
            transform: activeCategory === categories[i] ? "scale(1.15)" : "",
            boxShadow:
              activeCategory === categories[i] ? "0px 0px 3px #000000" : "",
          }}
        >
          <div className="d-flex justify-content-center" style={{}}>
            <img
              src={require("../assets/images/" + imageSrc)}
              alt="icons"
              style={{ padding: "10%", maxWidth: "100%" }}
            />
          </div>
        </Nav.Link>
      </Nav.Item>
    );
  }

  return (
    <div className="d-flex justify-content-center mt-sm-5 mt-4">
      <Nav
        onSelect={(eventKey) => setActiveCategory(eventKey)}
        justify="true"
        variant="pills"
        style={{
          paddingLeft: "4%",
          paddingRight: "6%",
          maxWidth: "2000px",
        }}
      >
        {items}
      </Nav>
    </div>
  );
}
